import { httpDomainService } from "../../http-common";
import { ICostingActivity } from "../../model/domainServices/ICostingActivity";
import { IPaginationResult } from "../../model/search/IPaginationResult";
import { ISearch } from "../../model/search/ISearch";

//Search
const getSearch = async (objISearch: ISearch) => {
    const params = JSON.stringify({
      search: objISearch.search,
    //   sortBy: objISearch.sortBy,
    //   sortOrder: objISearch.sortOrder,
    //   filterBy: {
    //     columnName: "",
    //     columnValue: ""
    //   },
      paginationInfo: {
        perPage: objISearch.pagination.perPage,
        page: objISearch.pagination.page,
      },
    });
  
    const data = await httpDomainService.post<IPaginationResult<ICostingActivity>>(
      "/costing_activity/get",
      params,
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("domainService_token")}`,
        },
      }
    );
    
    return data;
  };

  const getById = async (id: string) => {
    const data = await httpDomainService.post<ICostingActivity>(
      `/costing_activity/get/${id}`,
      "",
      {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("domainService_token")}`,
        },
      }
    );
  
    return data;
  };
  
  export const CostingActivityService = {
    getSearch,
    getById,
  };

  export const getCostingActivity = (costingActivityStateResult:IPaginationResult<ICostingActivity>, costingActivityId:string) => {
    if(costingActivityStateResult != null)
    {
      const result = costingActivityStateResult.data.find(value => value.costingActivityId === costingActivityId);
      return result;
    }
    else{
      return undefined;
    }
  }

  export const bindCostingActivityDropdown = (CostingActivityPaginationResult:IPaginationResult<ICostingActivity>): {label:string,code:string,value:string}[] => {
    const options = [];
    
    if(CostingActivityPaginationResult != null)
    {
      for (let i = 0; i < CostingActivityPaginationResult.data.length; i++) {
        let obj = {label: CostingActivityPaginationResult.data[i].code + " - " + CostingActivityPaginationResult.data[i].description, code:CostingActivityPaginationResult.data[i].code ?? "", value: CostingActivityPaginationResult.data[i].costingActivityId};
        options.push(obj);
      }
    }

    return options;
  }